"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.makeNewCompany = exports.getPlanData = void 0;
var end2end_1 = require("@hudled/end2end");
var firestore_1 = require("firebase/firestore");
exports.getPlanData = (0, end2end_1.makeGetPlanData)(firestore_1.Timestamp);
exports.makeNewCompany = (0, end2end_1.makeMakeNewCompany)(firestore_1.Timestamp, localStorage);
